// Mirror of CssfPdfDiplomasSection.jsx (forced French): bar title + per-diploma
// 30/70 row (date+location left; title+school right).

import { AlignmentType } from "docx";
import { formatDate } from "../../../../utils/formatDate";
import { barSectionTitle, para, run, twoColumnRow } from "../../shared/wordHelpers";
import { CSSF_ACCENT, CSSF_TEXT, FONT_VERDANA } from "../../shared/wordTheme";
import { pxToPt, pxToTwips } from "../../shared/wordUnits";

const DOC_LANG = "fr";

export function buildCssfDiplomas( { data, props, translations } ) {
    const { diplomas } = data;
    const { isAnonymous } = props;
    const t = translations?.pdf ?? {};

    const elements = [ barSectionTitle( "DIPLOMES/CERTIFICATIONS", { accent: CSSF_ACCENT, font: FONT_VERDANA } ) ];

    diplomas
        .filter( diploma => diploma.from && ( diploma.to || diploma.isCurrent ) )
        .sort( ( a, b ) => a.order - b.order )
        .forEach( diploma => {
            const dateText = `${ formatDate( diploma.from, DOC_LANG ) } au ${ diploma.isCurrent ? t.isCurrentLabel : formatDate( diploma.to, DOC_LANG ) } ${ diploma.location ?? "" }`.trim();

            const left = [ para(
                run( dateText, { pt: pxToPt( 9 ), color: CSSF_ACCENT, font: FONT_VERDANA } ),
                { alignment: AlignmentType.RIGHT, spacing: { before: pxToTwips( 4 ), after: 0 } }
            ) ];

            const right = [
                para( run( diploma.diplomaTitle, { pt: pxToPt( 11 ), color: CSSF_TEXT, font: FONT_VERDANA } ), { spacing: { before: pxToTwips( 4 ), after: 0 } } ),
                para( run( isAnonymous ? t.diplomasSchoolLabel : diploma.schoolName, { pt: pxToPt( 9 ), color: CSSF_TEXT, font: FONT_VERDANA } ), { spacing: { before: pxToTwips( 4 ), after: 0 } } ),
            ];

            elements.push( twoColumnRow( left, right, { rightMarginLeftPx: 12 } ) );
        } );

    return elements;
}
